import React from "react";
import "./HillTrip.css";
import ManaliMountainEscape from "../../assets/ManaliMountainEscape.png";
import ShimlaHeritageRetreat from "../../assets/ShimlaHeritageRetreat.png";
import OotyScenicHillsTour from "../../assets/OotyScenicHillsTour.png";
import DarjeelingTeaParadise from "../../assets/DarjeelingTeaParadise.png";
import MunnarGreenValleyEscape from "../../assets/MunnarGreenValleyEscape.png";
import NainitalLakeViewHoliday from "../../assets/NainitalLakeViewHoliday.png";
import { useNavigate } from "react-router-dom";
const hillStationTrips = [
  {
    title: "Manali Mountain Escape",
    image: ManaliMountainEscape,
    description:
      "Discover the scenic beauty of Manali surrounded by snow capped peaks and lush valleys. Enjoy river rafting, peaceful nature walks, cozy cafes, and breathtaking mountain views during this refreshing hill station getaway.",
    link: "/tour-package-data",
  },
  {
    title: "Shimla Heritage Retreat",
    image: ShimlaHeritageRetreat,
    description:
      "Explore the charming streets of Shimla filled with colonial architecture and cool mountain air. Visit Mall Road, enjoy toy train rides, scenic viewpoints, and relaxing evenings in this peaceful hill destination.",
    link: "/tour-package-data",
  },
  {
    title: "Ooty Scenic Hills Tour",
    image: OotyScenicHillsTour,
    description:
      "Experience the beauty of Ooty with rolling tea gardens, misty hills, and serene lakes. Enjoy boat rides, botanical gardens, cool climate, and breathtaking viewpoints during this delightful hill station vacation.",
    link: "/tour-package-data",
  },
  {
    title: "Darjeeling Tea Paradise",
    image: DarjeelingTeaParadise,
    description:
      "Visit Darjeeling to witness stunning sunrise views over Kanchenjunga and lush tea plantations. Enjoy toy train journeys, peaceful monasteries, local markets, and refreshing mountain weather in this scenic hill retreat.",
    link: "/tour-package-data",
  },
  {
    title: "Munnar Green Valley Escape",
    image: MunnarGreenValleyEscape,
    description:
      "Explore the rolling green hills of Munnar covered with endless tea estates and misty landscapes. Enjoy waterfalls, wildlife sightings, cool breezes, and peaceful surroundings during this rejuvenating hill station adventure.",
    link: "/tour-package-data",
  },
  {
    title: "Nainital Lake View Holiday",
    image: NainitalLakeViewHoliday,
    description:
      "Relax in Nainital surrounded by beautiful lakes and scenic mountains. Enjoy boat rides, cable car views, charming markets, cool climate, and peaceful nature walks in this picturesque hill station destination.",
    link: "/tour-package-data",
  },
];

const HillTrip = () => {
  const navigate = useNavigate();
  return (
    <div className="hill-container">
      <h2 className="hill-title">Hill Station Packages</h2>

      <div className="hill-grid">
        {hillStationTrips.map((trip, index) => (
          <div
            className="hill-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="hill-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HillTrip;
